<template>
  <b-container fluid class="home-container">
    <b-row class="home-admin" align-v="center" align-h="center">
      <b-col lg="5" sm="6" md="5" cols="12">
        <b-row class="mt-5" align-h="center">
          <router-link to="/">
            <img src="@/assets/images/ucspadmin.png" href="/" alt />
          </router-link>
        </b-row>
      </b-col>
        <b-col lg="5">
          <b-row class="login-adviser" align-h="center">
            <input
              type="text"
              v-model="form.email"
              class="form-control login-input"
              placeholder="admin@ucsp.pe"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
          </b-row>
          <b-row align-h="center">
            <input
              type="password"
              v-model="form.password"
              class="form-control login-input mt-4"
              placeholder="Contraseña"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
          </b-row>
          <b-row align-h="center" class="mt-5">
            <button @click="login()" type="button" class="mt-3 home-button-login">INGRESAR</button>
          </b-row>
      </b-col>
    </b-row>


 
  </b-container>
</template>

<script>

export default {
  name: "Home",
  components: {},
  data: () => ({
    form: {
      email: "",
      password: ""
    }
  }),
  created() {
 
  },
  methods: {
    login() {
      this.$store.dispatch("loginAdmin", this.form)
        .then(response => {
           if (response.data) {
          this.$store.commit("setJwtToken", response.data.token);
          this.$store.commit("setUserData", response.data.user);
          this.$router.push("/admin/home");
        }
        })
        .catch(error => {
          console.log(error.message);
        });
    }
}
}
</script>